import { TemplateKey } from "PFApp/constants/templates";
import ButtonLink from "PFComponents/button/button_link";
import { useTranslation } from "react-i18next";

type AddRoleButtonProps = {
  activityId: number;
  roleKey?: TemplateKey.Role | TemplateKey.AuditRole;
};

export const AddRoleButton = ({ activityId, roleKey = TemplateKey.Role }: AddRoleButtonProps) => {
  const { t } = useTranslation("activities");

  const label = roleKey === "audit_role" ? t("show.parts.addAuditRole") : t("show.parts.addRole");
  return <ButtonLink href={`/activities/${roleKey}/new?parentActivityId=${activityId}`}>{label}</ButtonLink>;
};
